import { useMutation, useQueryClient } from 'react-query'

import { userRepository } from '@webapp/platform/iam/data-access/repositories/UserRepository'
import { type OrderDraftPreferredCreationFlowEnum } from '@webapp/platform/iam/entities/enums/OrderDraftPreferredCreationFlowEnum'
import { UserPreferenceKeys } from '@webapp/platform/iam/entities/enums/UserPreferenceKeys'
import { userPreferenceQueryConfig } from '@webapp/platform/iam/query-configs/userPreferenceQueryConfig'

type UseMutateOrderRequestFlowPreferenceReturn = {
  setOrderDraftPreferredCreationFlow: (
    preferredCreationFlow: OrderDraftPreferredCreationFlowEnum
  ) => Promise<void>
}

export const useMutateOrderRequestFlowPreference = (
  userId: number
): UseMutateOrderRequestFlowPreferenceReturn => {
  const queryClient = useQueryClient()

  const { mutateAsync } = useMutation({
    mutationFn: async (
      preferredCreationFlow: OrderDraftPreferredCreationFlowEnum
    ) => {
      return userRepository.setPreference(
        userId,
        UserPreferenceKeys.ORDER_REQUEST_FLOW,
        preferredCreationFlow
      )
    },
    onSuccess: () => {
      queryClient.invalidateQueries(
        userPreferenceQueryConfig.getOrderRequestFlow(userId).queryKey
      )
    },
  })

  return {
    setOrderDraftPreferredCreationFlow: mutateAsync,
  }
}
